module.exports = __webpack_public_path__ + "img/image35.57dde4c9.jpg";